import React, { memo, useRef, useState, useEffect, useContext } from "react";
import { useDrop, useDrag } from "react-dnd";
import useDynamic from "../utils/usedynamic";
import { getEmptyImage } from "react-dnd-html5-backend";
import { PageDisbatch } from "../contexts/page";
import { EditorDisbatch, EditorValue } from "../contexts/editor";
import styles from "./styles.module.css";
function Dynamic(props) {
  const block = JSON.parse(props.block);
  const Component = useDynamic(block.dynamic);

  return (
    <div ref={props.editorRef} style={{ position: "relative" }}>
      <Component {...block.props} editor={true} />
    </div>
  );
}

export default memo(Dynamic);
